/**
 * Add Item To Cart Form
 *
 *
 * Events:
 *
 * @publishes cart-add-product <cart-fragment>
 *
 */

var _ = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var ShapewaysFormView = require('./ShapewaysFormView');

var ItemPurchaseForm = ShapewaysFormView.extend({

  submitTimeoutTime: $.swAjax.SW_TIMEOUT_TIME,

  swAttrs: {
    configurationInput: 'data-sw-item-purchase-form-configuration-input',
    modelIdInput: 'data-sw-item-purchase-form-model-id-input',
    materialIdInput: 'data-sw-item-purchase-form-material-id-input',
    buyNowBtn: 'data-sw-item-purchase-form-buy-button'
  },

  events: {
    'submit': 'onSubmit'
  },

  initialize: function() {

    this.$configurationInput = this.$(this.swSelectors.configurationInput);
    this.$modelIdInput = this.$(this.swSelectors.modelIdInput);
    this.$materialIdInput = this.$(this.swSelectors.materialIdInput);
    this.$buyButton = this.$(this.swSelectors.buyNowBtn);
    this.listenTo(this.model, 'change:currentConfigurationId', _.bind(this.swatchSelected, this));

    if (
      !this.$configurationInput.val() &&
      (!this.$modelIdInput.val() || !this.$materialIdInput.val())
    ) {
      this.disabled = true;
    }

    this.repaint();
  },

  render: function() {
    this.checkButtonState();
  },

  checkButtonState: function() {
    if (this.disabled) {
      this.$buyButton.addClass('disabled');
    } else {
      this.$buyButton.removeClass('disabled');
    }

    if (this.waiting) {
      this.$buyButton.addClass('waiting sw-dms-disabled-loading');
    } else {
      this.$buyButton.removeClass('waiting sw-dms-disabled-loading');
    }
  },

  swatchSelected: function(product, configurationId) {
    this.$configurationInput.val(configurationId);
    this.disabled = false;

    this.repaint();
  },

  onSubmit: function(e) {
    if (this.disabled) {
      return;
    }

    try{
      this.submitRequest();
      e.preventDefault();
    }
    catch(err){
      return true;
    }
  },

  submitRequest: function submitRequest() {
    var self = this;

    this.waiting = true;
    this.repaint();

    this.inlinePost({
      timeout: this.submitTimeoutTime,
      retryTimeout: function retryTimeout(jqXHR, textStatus, errorThrown, swInfo) {
        sw.on(swInfo.retryEventID, function() {
          self.waiting = true;
          self.repaint();
        });
        $.swAjax.triggerDefaultRetryNotey(swInfo.retryEventID);
      },
      error: function error(jqXHR, textStatus) {
        self.submitComplete();
        if(textStatus === $.swAjax.ERROR_TYPES.ERROR) {
          var responseText = JSON.parse(jqXHR.responseText);
          if(responseText !== undefined && responseText.isCartMaxed === true){
            $.swAjax.triggerCartMaxedNotey();
          } else {
            $.swAjax.triggerDefaultFailNotey();
          }
        }
       else if(textStatus !== $.swAjax.ERROR_TYPES.TIMEOUT) {
          $.swAjax.triggerDefaultFailNotey();
        }
      },
      success: function success(data) {
        self.submitSuccess(data);
      }
    });
  },

  submitComplete: function submitComplete() {
    this.waiting = false;
    this.repaint();
  },

  submitSuccess: function() {
    if(sw.data.isEmbed && sw.data.baseUrl) {
      parent.window.location = sw.data.baseUrl + '/cart';
    }
    sw.trigger('cart-add-product', '');
    this.submitComplete();
  }

});


module.exports = ItemPurchaseForm;
